import React from "react";
import { StyleSheet, View, Text, Image, TouchableOpacity } from "react-native";

import { MaterialIcons, Entypo } from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation } from "@react-navigation/core";

const ModalPurchase = ({ handleCloseModal, handleCloseWithTransaction, showTransactionSlip }) => {

    return (
        <>
            <View style={styles.headerLeft}>
                <MaterialIcons
                    onPress={handleCloseModal}
                    name="close"
                    size={30}
                    color="black"
                />
            </View>
            <View style={styles.container}>
                <Image
                    source={require("../../assets/success.png")}
                    style={styles.image2}
                />
                <Text style={styles.text}>
                    Sua {!showTransactionSlip && 'ordem de '}compra foi realizada com{" "}
                    <Text style={styles.success}>sucesso!</Text>
                </Text>

                {
                    showTransactionSlip &&
                    <TouchableOpacity style={styles.button} onPress={async () => { handleCloseWithTransaction() }}>
                        <Text style={styles.link}>VER COMPROVANTE</Text>
                    </TouchableOpacity>
                }
                <Image
                    source={require("../../assets/imgs/gpxcoinModal.png")}
                    style={styles.cardCoin}

                />
            </View>
        </>
    );
};

const styles = StyleSheet.create({
    container: {
        position: "relative",
        flex: 1,
        justifyContent: "flex-start",
        alignItems: "center",
        padding: 5,
        marginTop: 35,
    },
    button: {
        outlineStyle: 'none'
    },
    link: {
        fontWeight: "bold",
        textAlign: "center",
        fontSize: 12,
        marginVertical: 100,
        color: "#228c9a",
        fontSize: 14,

    },
    headerLeft: {
        padding: 25,
        alignItems: "flex-end",
        flexDirection: "row",
        justifyContent: "space-between",
    },
    headerRight: {
        marginTop: 25,
        padding: 15,
        alignItems: "flex-end",
    },
    image1: { width: "35%", height: "47%", resizeMode: "stretch" },
    image2: { width: 90, height: 90 },
    text: {
        fontSize: 18,
        marginTop: 30,
        textAlign: "center",
    },
    success: {
        fontWeight: "bold",
        color: "#1FBFB5",
    },
    cardCoin: {
        flex: 1,
        width: 300,
        height: 300,
        position: "absolute",
        right: -50,
        bottom: -50,
    },
});

export default ModalPurchase;
